import { render, staticRenderFns } from "./extrotec.vue?vue&type=template&id=40b3a315&scoped=true"
import script from "./extrotec.vue?vue&type=script&lang=js"
export * from "./extrotec.vue?vue&type=script&lang=js"
import style0 from "./extrotec.vue?vue&type=style&index=0&id=40b3a315&prod&lang=scss&scoped=true"
import style1 from "./extrotec.vue?vue&type=style&index=1&id=40b3a315&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3a315",
  null
  
)

export default component.exports